import * as React from "react";
import {
  ActivityFragment,
  TemplateFragment,
  CompanyMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { TemplateIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type TemplateCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: TemplateFragment;
};

export function isTemplateCreatedActivity(
  q: ActivityFragment
): q is TemplateCreatedActivity {
  return q.key === "template.created";
}

interface TemplateCreatedActivityProps {
  activity: TemplateCreatedActivity;
}

export const TemplateCreatedActivity: React.FC<TemplateCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="templateCreatedActivity"
      visual={<TemplateIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.templateCreated", {
          template: (
            <Link
              to={`/templates/${activity.trackable.slug}/edit`}
              key={activity.id}
            >
              {t("activity.objects.template")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
